import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AutomationLogsComponent } from '@tv3/containers/automations/automation-logs/table/automation-logs.component'
import { AutomationLogsDialogComponent } from '@tv3/containers/automations/automation-logs/dialog/automation-logs-dialog.component'
import { AutomationLogsDialogService } from '@tv3/containers/automations/automation-logs/dialog/automation-logs-dialog.service'
import { SharedModule } from '@tv3/shared/shared.module'
import { ExtraSharedModule } from '@tv3/containers/extras/shared/extra-shared.module'
import { ChargesSharedModule } from '@tv3/containers/charges/charges-shared.module'
import { InventoriesLibraryModule } from '@tokeet-frontend/inventories'
import { SecurityDepositOverlayModule } from '@tv3/containers/security-deposits/overlays/security-deposit-overlay/security-deposit-overlay.module'

const components = [
  //
  AutomationLogsComponent,
  AutomationLogsDialogComponent,
]

const services = [
  //
  AutomationLogsDialogService,
]

const modules = [
  //
  SharedModule,
  ExtraSharedModule,
  ChargesSharedModule,
  InventoriesLibraryModule,
  SecurityDepositOverlayModule,
]

@NgModule({
  declarations: [...components],
  imports: [CommonModule, ...modules],
  providers: [...services],
  exports: [...components, ...modules],
})
export class AutomationLogsModule {}
